export enum ESize {
  XL = 'XL',
  L = 'L',
  M = 'M',
  S = 'S',
  XS = 'XS',
}

export type TSize = keyof typeof ESize;

export enum EPlacementY {
  top = 'top',
  bottom = 'bottom',
}

export enum EPlacementX {
  left = 'left',
  center = 'center',
  right = 'right',
}

export type TPlacementY = keyof typeof EPlacementY;
export type TPlacementX = keyof typeof EPlacementX;

export enum EEvent {
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  ADD_NEW_NOTIFICATION = 'ADD_NEW_NOTIFICATION',
  REMOVE_NEW_NOTIFICATION = 'REMOVE_NEW_NOTIFICATION',
  REMOVE_ALL_MODALS = 'REMOVE_ALL_MODALS',
  MODAL = 'MODAL',
}

export enum EStackDirection {
  ROW = 'ROW',
  COLUMN = 'COLUMN',
}

export type TSpacingSize =
  | '0'
  | '05'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12';
